import React, { useRef, useContext } from "react";
import LoadingBar from "react-top-loading-bar";

const TopLoaderContext = React.createContext({loader: null});

export const useToploaderContext = () => {
  return useContext(TopLoaderContext);
};

const TopLoader = ({ children }) => {
  const loadingRef = useRef(null);
  return (
    <TopLoaderContext.Provider value={{ loader: loadingRef }}>
      <LoadingBar ref={loadingRef} waitingTime={400} color="#4361EE" />
      {children}
    </TopLoaderContext.Provider>
  );
};

export default TopLoader;
